import Cookies from 'js-cookie';
import Marketo from '../integrations/marketo';

class GatedResource {
	constructor(el) {
		this.el = el;
		this.formId = parseInt(el.getAttribute('data-gated-form-id'), 10);

		if (this.formId) {
			this.addSubmitHandler();
		}
	}

	addSubmitHandler() {
		Marketo.emitter.on('submit-success', ({ formObj }) => {
			const submitFormId = parseInt(formObj.formid ?? '0', 10);

			if (submitFormId === this.formId) {
				Cookies.set(`marketo_form_id_${this.formId}_submit`, '1');
			}
		});
	}
}

export default GatedResource;
